export default {
  items: [
    {
      name: "Dashboard",
      url: "/dashboard",
      icon: "icon-speedometer",
    },
    {
      name: "Urgent Orders",
      url: "/orders",
      icon: "nav-icon nav-icon nav-icon fa fa-bolt ",
    },
    {
      name: "Normal Orders",
      url: "/normal-orders",
      icon: "nav-icon nav-icon nav-icon fa fa-truck",
    },
    {
      name: "Invoices",
      url: "/invoices",
      icon: "nav-icon nav-icon nav-icon fa fa-file",
    },
    {
      name: "Receipts",
      url: "/payments",
      icon: "nav-icon nav-icon nav-icon fa fa-inr",
    },
    {
      name: "Sales Returns",
      url: "/salesreturns",
      icon: "nav-icon cui-action-undo",
    },
    {
      name: "Expiry Returns",
      url: "/expiryreturns",
      icon: "nav-icon fa fa-hourglass-end",
    },
    {
      name: "Credit Notes",
      url: "/creditnotes",
      icon: "nav-icon nav-icon nav-icon fa fa-credit-card-alt",
    },
    {
      name: "Users",
      url: "/users",
      icon: "nav-icon fa fa-users",
    },
    {
      name: "Support Tickets",
      url: "/support",
      icon: "nav-icon nav-icon nav-icon fa fa-life-ring",
    },
    // {
    //   name: "Notifications",
    //   url: "/notifications",
    //   icon: "nav-icon nav-icon nav-icon fa fa-life-ring"
    // }
  ],
};
